var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraTicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#E6EBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7818 12.0085L16.1468 23.2372L13.0593 19.9385C12.4905 19.4022 11.5968 19.3697 10.9468 19.8247C10.313 20.296 10.1343 21.1247 10.5243 21.791L14.1805 27.7385C14.538 28.291 15.1555 28.6322 15.8543 28.6322C16.5205 28.6322 17.1543 28.291 17.5118 27.7385C18.0968 26.9747 29.2605 13.666 29.2605 13.666C30.723 12.171 28.9518 10.8547 27.7818 11.9922V12.0085Z",
    fill: "#5384CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraTicks);
export default __webpack_public_path__ + "static/media/ExtraTicks.19c4cd2e38cad90c4305fff062595359.svg";
export { ForwardRef as ReactComponent };